import types from './types.js'

const clearSong = () => ({
  type: types.CLEAR_SONG
})

const decrementOffset = () => ({
  type: types.DECREMENT_OFFSET
})

const getState = () => ({
  type: types.GET_STATE
})

const incrementOffset = () => ({
  type: types.INCREMENT_OFFSET
})

const incrementTimer = () => ({
  type: types.INCREMENT_TIMER
})

const playerStop = () => ({
  type: types.PLAYER_STOP
})

const resetTimer = () => ({
  type: types.RESET_TIMER
})

const setOffset = (offset) => ({
  type: types.SET_OFFSET,
  offset
})

const startTimer = (position, duration) => ({
  type: types.START_TIMER,
  position,
  duration
})

const stopTimer = () => ({
  type: types.STOP_TIMER
})

const toggleMinimizedApp = () => ({
  type: types.TOGGLE_MINIMIZED_APP
})

const toggleOffsetView = () => ({
  type: types.TOGGLE_OFFSET_VIEW
})

const updateSong = (song, status) => ({
  type: types.UPDATE_SONG,
  status,
  song
})

const updateStatus = (status) => ({
  type: types.UPDATE_STATUS,
  status
})

export default {
  clearSong,
  decrementOffset,
  getState,
  incrementOffset,
  incrementTimer,
  playerStop,
  resetTimer,
  setOffset,
  startTimer,
  stopTimer,
  toggleMinimizedApp,
  toggleOffsetView,
  updateSong,
  updateStatus
}



// WEBPACK FOOTER //
// ./src/duck/actions.js